import { useTranslation } from 'react-i18next'

import Option from 'common/components/dataEntry/components/Option'
import { Select } from 'common/components/dataEntry/formik'

import { Button } from 'common/components'

type SelectServiceProviderProps = {
  inputName: string
  onChange: (arg: any) => any
  providers: string[]
  defaultValue?: any
}

function SelectServiceProvider({
  inputName,
  onChange,
  providers,
  defaultValue = undefined,
}: SelectServiceProviderProps) {
  const { t: translate } = useTranslation(['ee-dashboard', 'translation'])

  return (
    <Select
      label={translate('get-reimburse.request.service-provider-label')}
      labelStyles="mb-12"
      showSearch={true}
      name={inputName}
      placeholder={translate('get-reimburse.request.service-provider-description')}
      className="service_provider_select"
      showRequiredSign={true}
      onChange={onChange}
      defaultValue={defaultValue}
      dropdownRender={(menu) => (
        <>
          {menu}
          <Button
            className="w-100 flex flex__align_center"
            type="text"
            icon="fa fa-plus"
            onClick={() => onChange('add')}
          >
            {translate('get-reimburse.request.add-service-provider-label')}
          </Button>
        </>
      )}
    >
      {providers?.map((item: string) => (
        <Option key={item} value={item}>
          {item}
        </Option>
      ))}
    </Select>
  )
}

export default SelectServiceProvider
